module.exports = __webpack_public_path__ + "static/media/4r_website_logo_sup_taeehk.6b1a8ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4r_website_logo_sup_taeehk.jpg
// module id = 71
// module chunks = 0